// src/services/meetingService.ts
import { api } from './api';
import { Meeting, CreateMeetingDto, UpdateMeetingDto, CreateActionPointDto } from 'types/meeting';

export const meetingService = {
  getAll: async (scope?: 'upcoming' | 'today' | 'past'): Promise<Meeting[]> => {
    const { data } = await api.get('/meetings', { params: scope ? { scope } : {} });
    return data;
  },

  getOne: async (id: string): Promise<Meeting> => {
    const { data } = await api.get(`/meetings/${id}`);
    return data;
  },

  create: async (dto: CreateMeetingDto): Promise<Meeting> => {
    const { data } = await api.post('/meetings', dto);
    return data;
  },

  update: async (id: string, dto: UpdateMeetingDto): Promise<Meeting> => {
    const { data } = await api.patch(`/meetings/${id}`, dto);
    return data;
  },

  delete: async (id: string): Promise<void> => {
    await api.delete(`/meetings/${id}`);
  },

  cancel: async (id: string): Promise<Meeting> => {
    const { data } = await api.patch(`/meetings/${id}/cancel`);
    return data;
  },

  complete: async (id: string, minutes?: string): Promise<Meeting> => {
    const { data } = await api.patch(`/meetings/${id}/complete`, { minutes });
    return data;
  },

  updateMinutes: async (id: string, minutes: string): Promise<Meeting> => {
    const { data } = await api.patch(`/meetings/${id}/minutes`, { minutes });
    return data;
  },

  markAttendance: async (id: string, attended: boolean, userId?: string): Promise<Meeting> => {
    const { data } = await api.patch(`/meetings/${id}/attendance`, { attended, userId });
    return data;
  },

  addActionPoint: async (id: string, dto: CreateActionPointDto): Promise<Meeting> => {
    const { data } = await api.post(`/meetings/${id}/action-points`, dto);
    return data;
  },

  updateActionPoint: async (id: string, apId: string, dto: { done?: boolean; text?: string; dueDate?: string | null }): Promise<Meeting> => {
    const { data } = await api.patch(`/meetings/${id}/action-points/${apId}`, dto);
    return data;
  },

  deleteActionPoint: async (id: string, apId: string): Promise<Meeting> => {
    const { data } = await api.delete(`/meetings/${id}/action-points/${apId}`);
    return data;
  },

  addAttachment: async (id: string, meta: { name: string; url: string; key: string; size: number; mimeType: string }): Promise<Meeting> => {
    const { data } = await api.post(`/meetings/${id}/attachments`, meta);
    return data;
  },

  deleteAttachment: async (id: string, aid: string): Promise<Meeting> => {
    const { data } = await api.delete(`/meetings/${id}/attachments/${aid}`);
    return data;
  },
};
